import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import ColourDropDownFIlter from "../../../../components/FilterBox/ColourFilter/ColourDropDownFIlter";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { FiMenu } from "react-icons/fi";
import ColourParentChild from "../../../../components/Tables/ColourParentChild";
import {
  ColorMasterwise7Table,
  ColorMasterwise7TableFun,
  ColourFilter,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { Loader } from "../../../../components/Loader/Loader";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";

export const MachineGroupCostingSummary = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ColorMasterwise7TableData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState(null);

  const [selectedMachineGroup, setSelectedMachineGroup] = useState("");
  const [selectedMachineGroupId, setSelectedMachineGroupId] = useState(null);

  const [selectedMachine, setSelectedMachine] = useState("");
  const [selectedMachineId, setSelectedMachineId] = useState(null);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const [filter, setFilter] = useState({
    productionGroup: [],
    machineGroup: [],
    machineName: [],
  });
  const [search, setSearch] = useState({
    productionGroup: "",
    machineGroup: "",
    machineName: "",
  });

  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  const machineGroupList = ColourfilterData?.MachineGroup?.map((item) => ({
    label: item?.MachineGroupMstName,
    value: item?.MachineGroupMstID,
  }));

  const machineNameList = ColourfilterData?.Machine?.map((item) => ({
    label: item?.MachineMstName,
    value: item?.MachineMstID,
  }));

  // useEffect(() => {
  //   dispatch(ColourFilter());
  //   dispatch(
  //     ColorMasterwise7Table({
  //       FirmIDs: Firm,
  //       AcYearIDs: FinancialYear,
  //       ProductionGroupIds: filter.productionGroup.join(","),
  //       MachineGroupMstIDs: filter.machineGroup.join(","),
  //       MachineIds: filter.machineName.join(","),
  //       StartDate: safeFormat(startDate),
  //       EndDate: safeFormat(endDate),
  //     }),
  //   );
  // }, [dispatch, Firm, FinancialYear]);

  useEffect(() => {
    dispatch(ColourFilter());
  }, [dispatch]);

  const isApiCalled = useRef(false);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (isApiCalled.current) return;

    isApiCalled.current = true;

    dispatch(
      ColorMasterwise7Table({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ProductionGroupIds: "",
        MachineGroupMstIDs: "",
        MachineIds: "",
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, FinancialYear, startDate, endDate]);

  // 🔷 Dummy Columns
  const columns = [
    {
      label: "Machine Group",
      key: "MachineGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Machine Name", key: "MachineMstName", align: "left", colors: isdark === "light" ? "#000" : "#fff", },
    {
      label: "Consumption Amount",
      key: "CostAmount",
      align: "right",
      format: "true",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    {
      label: "Final Meter",
      key: "FinalPrdMtr",
      align: "right",
      format: "true",
    },
    {
      label: "Cost Per Meter",
      key: "PMeterCost",
      align: "right",
      format: "true",
    },
  ];

  const rows = (ColorMasterwise7TableData?.Detail || []).map((row) => ({
    MachineMstID: row.MachineMstID || "",
    MachineGroupMstName: row.MachineGroupMstName || "",
    MachineMstName: row.MachineMstName || "",
    Meter: row.Meter || "",
    CostAmount: row.CostAmount || "",
    FinalPrdMtr: row.FinalPrdMtr || "",
    PMeterCost: row.PMeterCost || "",
  }));
  // 🔷 Date
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const handleSubmit = () => {
    dispatch(ColorMasterwise7TableFun());

    dispatch(
      ColorMasterwise7Table({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,

        ProductionGroupIds: selectedProductionId
          ? selectedProductionId.toString()
          : "",

        MachineGroupMstIDs: selectedMachineGroupId
          ? selectedMachineGroupId.toString()
          : "",

        MachineIds: selectedMachineId ? selectedMachineId.toString() : "",

        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  };

  const applyFilter1 = () => {
    dispatch(ColorMasterwise7TableFun());

    dispatch(
      ColorMasterwise7Table({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,

        ProductionGroupIds: filter.productionGroup
          ? filter.productionGroup.toString()
          : "",

        MachineGroupMstIDs: filter.machineGroup
          ? filter.machineGroup.toString()
          : "",

        MachineIds: filter.machineName ? filter.machineName.toString() : "",

        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );

    setShowFilter(false);
  };
  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ColorMasterwise7TableData || ColorMasterwise7TableData === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>
      <Offcanvas show={showFilter} onHide={handleClose} placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Col style={{ flex: 1 }}>
              {/* DATE PICKER */}
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            </Col>
            <ColourFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <ColourFilterBox
              title="Machine Group"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filter.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />

            <ColourFilterBox
              title="Machine Name"
              items={machineNameList}
              search={search.machineName}
              setSearch={(val) => handleSearch("machineName", val)}
              selectedItems={filter.machineName}
              toggleItem={(item) => toggleItem("machineName", item)}
              selectAll={() => selectAll("machineName", machineNameList)}
            />
            <Button
              onClick={applyFilter1}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour4,
          padding: "15px",
          borderRadius: "12px",
          position: "relative",
          zIndex: 10,
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">
          {/* DATE */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour7 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "16px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8}`,
                  color: isdark === "light" ? iscolour?.Colour : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Production Group"
              data={productionGroupList}
              selectedValue={selectedProduction}
              setSelectedValue={setSelectedProduction}
              selectedId={selectedProductionId}
              setSelectedId={setSelectedProductionId}
              placeholder="Select Production"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Machine Group"
              data={machineGroupList}
              selectedValue={selectedMachineGroup}
              setSelectedValue={setSelectedMachineGroup}
              selectedId={selectedMachineGroupId}
              setSelectedId={setSelectedMachineGroupId}
              placeholder="Select Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Machine Name"
              data={machineNameList}
              selectedValue={selectedMachine}
              setSelectedValue={setSelectedMachine}
              selectedId={selectedMachineId}
              setSelectedId={setSelectedMachineId}
              placeholder="Select Machine"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* BUTTON */}
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3 hover-scale-btn ">
            <button
              onClick={handleSubmit}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            letterSpacing: "1px",
            fontSize: "18px"
          }}
        >
          MACHINE GROUPWISE DETAIL
        </div>

        <ColourParentChild
          columns={columns}
          data={rows}
          parentKey="MachineGroupMstName"
        />
      </div>

      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineGroupCostingSummary;
